module.exports = __webpack_public_path__ + "static/img/JAGGA-SMITH.87ce04a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/JAGGA-SMITH.jpg
// module id = fpqN
// module chunks = 0